export const getDependantsTriggersMap = element => element?.dependantsTriggersMap || {};

export const getDependantTriggers = (element, dependantId) => {
  const dependantsTriggersMap = getDependantsTriggersMap(element);

  if (Object.prototype.hasOwnProperty.call(dependantsTriggersMap, dependantId)) {
    return dependantsTriggersMap[dependantId] || [];
  }

  return element?.dependantsTriggers || [];
};

export const mergeDependantsTriggers = dependantsTriggersMap =>
  Object.values(dependantsTriggersMap).reduce((acc, optionIds) => {
    (optionIds || []).forEach(optionId => {
      if (!acc.includes(optionId)) {
        acc.push(optionId);
      }
    });

    return acc;
  }, []);

const mergeUniqueTriggers = (...triggersLists) =>
  triggersLists.flat().reduce((acc, optionId) => {
    if (!acc.includes(optionId)) {
      acc.push(optionId);
    }

    return acc;
  }, []);

export const resolveDependantsTriggers = (element, dependantsTriggersMap, dependantsIds) => {
  const mappedDependantsIds = Object.keys(dependantsTriggersMap);
  const legacyDependantsIds = (dependantsIds || element?.dependantsIds || []).filter(
    dependantId => !mappedDependantsIds.includes(dependantId),
  );
  const mappedTriggers = mergeDependantsTriggers(dependantsTriggersMap);
  const legacyTriggers = legacyDependantsIds.length ? element?.dependantsTriggers || [] : [];

  return mergeUniqueTriggers(mappedTriggers, legacyTriggers);
};

export const updateDependantTriggers = (element, dependantId, triggers) => {
  const dependantsTriggersMap = {
    ...getDependantsTriggersMap(element),
    [dependantId]: triggers,
  };

  return {
    dependantsTriggersMap,
    dependantsTriggers: resolveDependantsTriggers(element, dependantsTriggersMap),
  };
};

export const registerDependantTriggers = (element, dependantId, triggers = []) =>
  updateDependantTriggers(element, dependantId, triggers);

export const removeDependantFromTriggersMap = (element, dependantId, dependantsIds) => {
  const dependantsTriggersMap = { ...getDependantsTriggersMap(element) };
  delete dependantsTriggersMap[dependantId];

  return {
    dependantsTriggersMap,
    dependantsTriggers: resolveDependantsTriggers(element, dependantsTriggersMap, dependantsIds),
  };
};

export const removeOptionFromTriggers = (element, optionId) => {
  const dependantsTriggersMap = Object.entries(getDependantsTriggersMap(element)).reduce(
    (acc, [dependantId, triggers]) => ({
      ...acc,
      [dependantId]: (triggers || []).filter(triggerId => triggerId !== optionId),
    }),
    {},
  );

  const remainingDependantsTriggers = resolveDependantsTriggers(
    element,
    dependantsTriggersMap,
  ).filter(triggerId => triggerId !== optionId);

  return {
    dependantsTriggersMap,
    dependantsTriggers: remainingDependantsTriggers,
  };
};
